<div class="modal fade" [class.show]="showModal" [style.display]="showModal ? 'block' : 'none'" 
     tabindex="-1" role="dialog" aria-labelledby="disclaimerModalLabel" aria-hidden="true"
     (click)="onModalClick($event)">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content disclaimer-modal-content">
            <div class="modal-header disclaimer-modal-header">
                <h5 class="modal-title" id="disclaimerModalLabel">
                    <i class="feather icon-alert-triangle me-2"></i>
                    {{ modalTitle }}
                </h5>
                <button type="button" class="btn-close btn-close-white" aria-label="Close" (click)="onClose()"></button>
            </div>
            
            <div class="modal-body">
                <div class="disclaimer-section mb-4">
                    <div class="d-flex align-items-start">
                        <i class="feather icon-alert-triangle text-warning me-3 disclaimer-icon"></i>
                        <div class="disclaimer-text">
                            <strong class="d-block mb-2">Disclaimer</strong>
                            <p class="mb-0">{{ disclaimerText }}</p>
                        </div>
                    </div>
                </div>
                <div class="acknowledgment-section">
                    <div class="alert alert-light border-warning d-flex align-items-start p-3">
                        <div class="form-check mb-0">
                            <input class="form-check-input acknowledgment-checkbox" type="checkbox" id="acknowledgmentCheckbox" 
                                [(ngModel)]="acknowledgmentChecked">
                            <label class="form-check-label ms-2" for="acknowledgmentCheckbox">
                                {{ acknowledgmentText }}
                            </label>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" (click)="onClose()">
                    {{ cancelButtonText }}
                </button>
                <button type="button" class="btn btn-primary" (click)="onConfirm()" [disabled]="!acknowledgmentChecked">
                    {{ confirmButtonText }}
                </button>
            </div>
        </div>
    </div>
</div>

